// LifeSchools.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import "../Style/lifeIndividuals.css";

const NS = "lifeSchoolsPage";

function Illustration({ suggestion, variant }) {
  return (
    <div className={`lifeX-figure ${variant ? `lifeX-figure--${variant}` : ""}`}>
      <div className="lifeX-illustration" role="img" aria-label={suggestion || "Illustration placeholder"} />
      {suggestion ? (
        <p className="lifeX-caption">
          <em>{suggestion}</em>
        </p>
      ) : null}
    </div>
  );
}

function ContentSection({ id, title, paragraphs = [], illustrationSuggestion, reverse = false }) {
  const safeParas = Array.isArray(paragraphs) ? paragraphs : [];
  return (
    <section id={id} className="lifeX-section" aria-labelledby={`${id}-title`}>
      <div className="lifeX-container">
        <div className={`lifeX-split ${reverse ? "lifeX-split--reverse" : ""}`}>
          <div className="lifeX-copy">
            <h2 className="lifeX-h2" id={`${id}-title`}>{title}</h2>
            <div className="lifeX-prose">
              {safeParas.map((p, i) => (
                <p key={`${id}-p-${i}`} className="lifeX-p">{p}</p>
              ))}
            </div>
          </div>

          <Illustration suggestion={illustrationSuggestion} />
        </div>
      </div>
    </section>
  );
}

function CTASection({ id, title, paragraphs = [], primaryCta, secondaryCta, illustrationSuggestion }) {
  const safeParas = Array.isArray(paragraphs) ? paragraphs : [];
  return (
    <section id={id} className="lifeX-section lifeX-section--cta" aria-labelledby={`${id}-title`}>
      <div className="lifeX-container">
        <div className="lifeX-ctaCard">
          <div className="lifeX-ctaCard__copy">
            <h2 className="lifeX-h2" id={`${id}-title`}>{title}</h2>
            <div className="lifeX-prose">
              {safeParas.map((p, i) => (
                <p key={`${id}-p-${i}`} className="lifeX-p">{p}</p>
              ))}
            </div>

            <div className="lifeX-ctaRow" role="group" aria-label="Actions">
              <a className="lifeX-btn lifeX-btn--primary" href={primaryCta?.href || "#"}>
                {primaryCta?.label}
              </a>
              <a className="lifeX-btn lifeX-btn--ghost" href={secondaryCta?.href || "#"}>
                {secondaryCta?.label}
              </a>
            </div>
          </div>

          {/* <Illustration suggestion={illustrationSuggestion} variant="cta" /> */}
        </div>
      </div>
    </section>
  );
}

export default function LifeSchools() {
  const { t } = useTranslation(NS);

  const seo = t("seo", { returnObjects: true });
  const hero = t("hero", { returnObjects: true });
  const sections = t("sections", { returnObjects: true });
  const closing = t("closing", { returnObjects: true });

  const safeSections = Array.isArray(sections) ? sections : [];
  const heroSubtitle = Array.isArray(hero?.subtitle) ? hero.subtitle : [];
  const closingParas = Array.isArray(closing?.paragraphs) ? closing.paragraphs : [];

  return (
    <main className="lifeX-page" aria-label={seo?.ariaLabel || "Life for Schools"}>
      <header className="lifeX-hero">
        <div className="lifeX-container">
          <div className="lifeX-hero__grid">
            <div className="lifeX-hero__copy">
              <h1 className="lifeX-h1">{hero?.title}</h1>

              <div className="lifeX-prose lifeX-prose--hero">
                {heroSubtitle.map((p, i) => (
                  <p key={`hero-sub-${i}`} className="lifeX-p lifeX-p--hero">{p}</p>
                ))}
              </div>

              <div className="lifeX-ctaRow" role="group" aria-label="Hero actions">
                <a className="lifeX-btn lifeX-btn--primary" href={hero?.primaryCta?.href || "#"}>
                  {hero?.primaryCta?.label}
                </a>
                <a className="lifeX-btn lifeX-btn--ghost" href={hero?.secondaryCta?.href || "#"}>
                  {hero?.secondaryCta?.label}
                </a>
              </div>
            </div>

            <Illustration suggestion={hero?.illustrationSuggestion} variant="hero" />
          </div>
        </div>
      </header>

      {safeSections.map((s, idx) => (
        <ContentSection
          key={s.id}
          id={s.id}
          title={s.title}
          paragraphs={s.paragraphs}
          // illustrationSuggestion={s.illustrationSuggestion}
          // reverse={idx % 2 === 1}
        />
      ))}

      <CTASection
        id="closing"
        title={closing?.title}
        paragraphs={closingParas}
        primaryCta={closing?.primaryCta}
        secondaryCta={closing?.secondaryCta}
        // illustrationSuggestion={closing?.illustrationSuggestion}
      />
    </main>
  );
}